import { Row } from "../Row";

/** Used by `<Suspense/>` to render its loading `fallback` */
export const LoadingRow = () => {
  return <Row isLoading />;
};
